import React from "react";
import {ButtonIconDelete, ButtonIconEdit} from "../../../../../Components/Inputs";
import {getInventoryStatusTextByValue} from "../../loanLibraryConstants";
import {getLoanLibraryInventoryItemId} from "./loanLibraryInventoryUtility";
import {convertToDateTimeString} from "../../../../../Utilities/Types/dateUtilities";

interface LoanLibraryInventoryRowProps {
    handleDeleteInventoryItem: (index: number) => void;
    handleEditInventoryItem: (index: number) => void;
    index: number;
    loanLibraryInventoryItem: Record<string, any>;
}

export const LoanLibraryInventoryRow = ({
                                            handleDeleteInventoryItem,
                                            handleEditInventoryItem,
                                            index,
                                            loanLibraryInventoryItem,
                                        }: LoanLibraryInventoryRowProps) => {

    const handleClickEditInventoryItem = () => {
        handleEditInventoryItem(index);
    };

    const handleClickDeleteInventoryItem = () => {
        handleDeleteInventoryItem(index);
    };

    const loanLibraryInventoryItemId = getLoanLibraryInventoryItemId(loanLibraryInventoryItem, index);

    return <>
        <tr id={loanLibraryInventoryItemId} data-testid={loanLibraryInventoryItemId}>
            <td>{loanLibraryInventoryItem.shortId || ''}</td>
            <td>
                {loanLibraryInventoryItem.copyNumber}
            </td>
            <td>
                {loanLibraryInventoryItem.shelfLocation}
            </td>
            <td>
                {loanLibraryInventoryItem.serialNumber}
            </td>
            <td>
                {loanLibraryInventoryItem.assetNumber}
            </td>
            <td>
                {getInventoryStatusTextByValue(loanLibraryInventoryItem.status)}
            </td>
            <td>
                {loanLibraryInventoryItem.notes}
            </td>
            <td>
                {convertToDateTimeString(loanLibraryInventoryItem.dateOfPurchase)}
            </td>
            <td>
                <ButtonIconEdit
                    inputDescription={`edit copy ${index + 1}`}
                    onClick={() => handleClickEditInventoryItem()}
                />
                <ButtonIconDelete
                    inputDescription={`delete copy ${index + 1}`}
                    onClick={() => handleClickDeleteInventoryItem()}
                />
            </td>
        </tr>
    </>;
};